<div [ngClass]="appearance">
  @if (!shouldHideHeaders) {
    <div class="headers" [class.primary]="isBars" [class.mat-elevation-z1]="isBars">
      <mat-grid-list gutterSize="0" [cols]="columns" [rowHeight]="headerHeight">
        @for (header of config; track $index) {
          <mat-grid-tile
            class="w-full text-center text-xs font-extrabold uppercase leading-4 tracking-wider"
            [ngClass]="header.headerClass"
            [colspan]="header.columns"
            [class.mat-h2]="isBars"
            [matTooltip]="header.shouldDetectHeaderClick ? null : header.tooltip"
            [matTooltipDisabled]="header.isDisabled"
          >
            @if (header.shouldDetectHeaderClick) {
              <button
                mat-stroked-button
                [matTooltip]="header.tooltip"
                [matTooltipDisabled]="header.isDisabled"
                (click)="handleHeaderClicked(header)"
              >
                {{ header.header }}
              </button>
            }
            @if (!header.shouldDetectHeaderClick) {
              <div class="w-full" [ngClass]="header.headerClass">
                {{ header.header }}
              </div>
            }
          </mat-grid-tile>
        }
      </mat-grid-list>
      @if (appearance === 'attachment') {
        <div class="border-b-2 border-black"></div>
      }
    </div>
  }
  <!-- this creates a total row in the same fashion as the elements below it. -->
  @if (!shouldHideTotal) {
    @for (totalEntity of total; track $index; let i = $index) {
      <div class="totalRowContainer w-full" [ngClass]="contentRowClasses">
        <mat-grid-list gutterSize="0" [cols]="columns" [rowHeight]="totalRowHeight">
          @for (totalRow of findValuesForList(totalEntity); track $index; let j = $index) {
            @for (totalColumn of config; track $index; let k = $index) {
              @if (!totalColumn.shouldSpanAllRows || j === 0) {
                <mat-grid-tile class="no-hover" [colspan]="totalColumn.columns">
                  <!-- eslint-disable-next-line @angular-eslint/template/no-any --  We have to force the value here because table-like is convoluted -->
                  <grid-switch [config]="totalColumn" [value]="findTotalValue($any(totalRow), totalColumn)" [isTotalRow]="true" />
                </mat-grid-tile>
              }
            }
          }
        </mat-grid-list>
      </div>
    }
  }
  <div class="container max-w-full" [ngClass]="containerClass">
    @for (entity of values; track $index; let i = $index) {
      @if (!entity.shouldNeverShow && entity.shouldShow !== false) {
        <div class="w-full" [ngClass]="contentRowClasses" [class.highlight]="entity.shouldHighlight">
          <mat-grid-list gutterSize="0" [cols]="columns" [rowHeight]="rowHeight">
            @for (row of findValuesForList(entity); track $index; let j = $index) {
              @for (columnConfig of findColumnConfigs(entity, row); track $index; let k = $index) {
                @if (!columnConfig.shouldSpanAllRows || j === 0) {
                  @if (!(isSimple && columnConfig.shouldSpanAllRows && i > 0)) {
                    <mat-grid-tile [colspan]="columnConfig.columns" [rowspan]="findRowSpan(columnConfig, entity, row)">
                      @if (columnConfig.hasInlineLabel) {
                        <div [ngClass]="labelClass">
                          {{ columnConfig.header }}
                        </div>
                      }
                      @if (entity.shouldFlag && k === 0) {
                        <span class="mr-1 size-6 rounded-xl bg-red-500 p-1 !leading-4 text-white">
                          <mat-icon [inline]="true">warning_amber</mat-icon>
                        </span>
                      }
                      <grid-switch
                        matTooltipPosition="left"
                        [matTooltipDisabled]="!(columnConfig.shouldShowEntityTooltip && entity.tooltip)"
                        [matTooltip]="entity.tooltip"
                        [config]="columnConfig"
                        [value]="findValueForGrid(row, columnConfig)"
                        [display]="findDisplay(row, columnConfig)"
                        [isTotalRow]="false"
                        [shouldHighlight]="shouldHighlight(i, j, k)"
                        [canEdit]="row.canEdit"
                        (numberBoxClicked)="handleNumberBoxClick(entity, columnConfig, i, j, k)"
                        (textClicked)="handleTextClicked(entity, columnConfig, row[columnConfig.key], i, j, k)"
                        (valueChanged)="handleChange($event, columnConfig, i, j, k)"
                        (plainButtonClicked)="handlePlainButtonClicked(entity, columnConfig, i, j, k)"
                        (iconClicked)="handleIconClicked(entity, columnConfig, i, j, k)"
                      />
                    </mat-grid-tile>
                  }
                }
              }
            }
          </mat-grid-list>
        </div>
      }
    }
  </div>
</div>
